import React, {
    useState,
    useEffect,
    useContext,
    ChangeEvent,
} from 'react'

import * as Contexts from '../../contexts'
import * as Page from '../../components/Page'
import * as Buttons from '../../components/Buttons'
import * as Components from './components'

import { config, Translater } from '../../config'
import { useHttp } from '../../hooks/http.hook'
import {useHistory, useParams} from 'react-router-dom'


const DetailPage: React.FC = () => {

    const { id } = useParams() as any
    const { token } = useContext(Contexts.AuthContext)
    const { language } = useContext(Contexts.LanguageContext)

    const history = useHistory()
    const { loading, request } = useHttp()

    const [primary, setPrimary] = useState<any | null>(null)
    const [isValid, toggleValid] = useState({
        sum: false,
        // photo: false,
    })

    const [form, setForm] = useState<any>({
        sum: 0,
    })

    const Events = {
        inputHandler: (e: ChangeEvent<HTMLInputElement>) => {
            //@ts-ignore
            if (e.target.type === 'file') setForm({ ...form, photo: e.target.files[0] })

            else setForm({ ...form, [e.target.name]: e.target.value })
        },
        /*  selectHandler: (e: ChangeEvent<HTMLSelectElement>) => {
              setForm({ ...form, [e.target.name]: e.target.value })
          }, */
        setCity: (city: string) => {
            setForm({ ...form, city})
        },
        /*  setRole: (role: string) => {
              setForm({ ...form, role })
          }, */
        saveHandler: () => {
            if (isValid.sum) Callbacks.Save()
        },
        deleteHandler: () => {
            const answer = window.confirm(Translater.Alert.delete[language.slug])
            if (answer) Callbacks.Delete()
        },
    }

    const Callbacks = {
        Fetch: async () => {
            try {
                const response: any = await request(`${config.API}/referals/${id}`,
                    'GET', null, {
                        Authorization: (token as string)
                    })

                if (response) {
                    setPrimary(response)
                }
            } catch (e) {
                console.log(e)
            }
        },
        Save: async () => {
            try {

                const response = await request(`${config.API}/referals/${primary?._id}`, 'POST', { sum: form.sum }, {
                    Authorization: (token as string),
                })

                if (response) {
                    history.goBack()
                }
            } catch (e) {
                console.log(e)
            }
        },
        Delete: async () => {
            try {
                await request(`${config.API}/referals/${id}`, 'DELETE', null, {
                    Authorization: (token as string),
                })

                history.push('/referals')
            } catch (e) {
                console.log(e)
            }
        },
    }

    useEffect(() => {
        Callbacks.Fetch()
    }, [id])

    useEffect(() => {
        if (primary) setForm({
            ...form,
            sum: primary.sum,
        })
    }, [primary])

    useEffect(() => {
        if (form.sum > 0) toggleValid({ ...isValid, sum: true })
        else toggleValid({ ...isValid, sum: false })
    }, [form.sum])

    /*    useEffect(() => {
            if (form.photo) toggleValid({ ...isValid, photo: true })
            else toggleValid({ ...isValid, photo: false })
        }, [form.photo]) */


    return (
        <Page.Wrapper
            title={Translater.ReferalsDetailPage.title[language.slug]}
        >
            <Page.Header
                backButtonTitle={Translater.ReferalsDetailPage.title[language.slug]}
            />

            <Buttons.Container
                disabled={loading}
                saveHandler={Events.saveHandler}
                deleteHandler={Events.deleteHandler}
            />

            <Components.ConfigBlock
              //  isCreate
                form={form}
                isValid={isValid}
                //  setCity={Events.setCity}
                inputHandler={Events.inputHandler}
                //  selectHandler={Events.selectHandler}
            />

        </Page.Wrapper>
    )
}

export default DetailPage
